import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography
} from '@mui/material';

/**
 * Dialog component for collecting detailed feedback when user gives thumbs down
 */
const FeedbackDialog = ({ open, onClose, onSubmit }) => {
  const [feedbackType, setFeedbackType] = useState('improvement');
  const [feedbackText, setFeedbackText] = useState('');
  const [name, setName] = useState('');

  // Reset form when dialog closes
  const handleClose = () => {
    setFeedbackType('improvement');
    setFeedbackText('');
    setName('');
    onClose();
  };

  // Submit feedback and close dialog
  const handleSubmit = () => {
    onSubmit({
      type: feedbackType,
      comment: feedbackText,
      name: name.trim()
    });
    handleClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      fullWidth 
      maxWidth="sm"
      aria-labelledby="feedback-dialog-title"
    >
      <DialogTitle id="feedback-dialog-title">
        Help Us Improve
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          We're sorry the response wasn't helpful. Please tell us how we can do better.
        </Typography>
        
        <FormControl component="fieldset" margin="normal" fullWidth>
          <FormLabel component="legend">What type of feedback would you like to provide?</FormLabel>
          <RadioGroup
            name="feedbackType"
            value={feedbackType}
            onChange={(e) => setFeedbackType(e.target.value)}
          >
            <FormControlLabel value="improvement" control={<Radio />} label="Suggest an improvement" />
            <FormControlLabel value="question" control={<Radio />} label="Ask a question" />
            <FormControlLabel value="bug" control={<Radio />} label="Report a bug" />
          </RadioGroup>
        </FormControl>
        
        <TextField
          label="Your feedback"
          multiline
          rows={4}
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
          fullWidth
          margin="normal"
          placeholder="Please provide details about your feedback..."
          variant="outlined"
        />
        {/* Name field required for negative feedback */}
        <TextField
          label="Your Name (required)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="normal"
          required
          variant="outlined"
          style={{ display: feedbackType === 'improvement' || feedbackType === 'question' || feedbackType === 'bug' ? 'block' : 'none' }}
        />
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          color="primary" 
          variant="contained" 
          disabled={
            !feedbackText.trim() ||
            ((feedbackType === 'improvement' || feedbackType === 'question' || feedbackType === 'bug') && !name.trim())
          }
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackDialog;
